import { NgModule } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule } from "../components/components.module";
import { CustomDateDirectiveModule } from "../directives/custom-date.directive";
import { DecimalNumberDirectiveModule } from "../directives/decimal-number";
import { AngularMaterialModule } from "../modules/angular-material/angular-material.module";
import { DetailModule } from "../modules/detail/detail.module";
import { AccountCellRendererComponent } from "./account-cell-renderer/account-cell-renderer.component";
import { AddressCellRendererComponent } from "./address-cell-renderer/address-cell-renderer.component";
import { AmountInShipmentCellRendererComponent } from "./amount-in-shipment-cell-renderer/amount-in-shipment-cell-renderer.component";
import { AvgPriceTooltipCellRendererComponent } from "./avg-price-tooltip-cell-renderer/avg-price-tooltip-cell-renderer.component";
import { BooleanCellRendererComponent } from "./boolean-cell-renderer/boolean-cell-renderer.component";
import { BooleanFilterComponent } from "./boolean-filter/boolean-filter.component";
import { BtnCellRendererComponent } from "./btn-cell-renderer/btn-cell-renderer.component";
import { BuyBoxCellEditorComponent } from "./buy-box--cell-editor/buy-box-cell-editor.component";
import { BuyBoxCellRendererComponent } from "./buy-box-cell-renderer/buy-box-cell-renderer.component";
import { ChannelsCellRendererComponent } from "./channels-cell-renderer/channels-cell-renderer.component";
import { CheckboxCellRendererComponent } from "./checkbox-cell-renderer/checkbox-cell-renderer.component";
import { ColumnSelectorHeaderRendererComponent } from "./column-selector-header-renderer/column-selector-header-renderer.component";
import { DateCellRendererComponent } from "./date-cell-renderer/date-cell-renderer.component";
import { DeleteIconRendererComponent } from "./delete-icon-renderer/delete-icon-renderer.component";
import { DiscountPricePercentCellEditComponent } from "./discount-price-percent-cell-edit/discount-price-percent-cell-edit.component";
import { GridCheckboxHeaderRendererComponent } from "./grid-checkbox-header-renderer/grid-checkbox-header-renderer.component";
import { ImageCellRendererComponent } from "./image-cell-renderer/image-cell-renderer.component";
import { InternalNoteCellRendererComponent } from "./internal-note-cell-renderer/internal-note-cell-renderer.component";
import { ItemListCellRendererComponent } from "./item-list-cell-renderer/item-list-cell-renderer.component";
import { LinkCellRendererComponent } from './link-cell-renderer/link-cell-renderer.component';
import { LoadingCellRendererComponent } from "./loading-cell-renderer/loading-cell-renderer.component";
import { MultiEditComponent } from "./multi-edit/multi-edit.component";
import { MultiFieldCellRendererComponent } from "./multi-field-cell-renderer/multi-field-cell-renderer.component";
import { MultiPriceCellRendererComponent } from "./multi-price-cell-renderer/multi-price-cell-renderer.component";
import { MultiSkuToolPanelComponent } from "./multi-sku-tool-panel/multi-sku-tool-panel.component";
import { NoteCellRendererComponent } from "./note-cell-renderer/note-cell-renderer.component";
import { NumberAndTrendCellRendererComponent } from "./number-and-trend-cell-renderer/number-and-trend-cell-renderer.component";
import { OffersCellRendererComponent } from "./offers-cell-renderer/offers-cell-renderer.component";
import { OrderInfoCellRendererComponent } from "./order-info-cell-renderer/order-info-cell-renderer.component";
import { OrderStatusCellRendererComponent } from "./order-status-cell-renderer/order-status-cell-renderer.component";
import { PriceOverrideCellEditorComponent } from "./price-override-cell-editor/price-override-cell-editor.component";
import { PriceOverrideCellRendererComponent } from "./price-override-cell-renderer/price-override-cell-renderer.component";
import { RankCellRendererComponent } from "./rank-cell-renderer/rank-cell-renderer.component";
import { ReceivedQtyCellEditComponent } from './received-qty-cell-edit/received-qty-cell-edit.component';
import { RepricingModelCellEditorComponent } from "./repricing-model-cell-editor/repricing-model-cell-editor.component";
import { RepricingModelCellRendererComponent } from "./repricing-model-cell-renderer/repricing-model-cell-renderer.component";
import { RoundCheckboxCellRendererComponent } from './round-checkbox-cell-renderer/round-checkbox-cell-renderer.component';
import { SelectFilterComponent } from "./select-filter/select-filter.component";
import { SelectOptionCellRendererComponent } from "./select-option-cell-renderer/select-option-cell-renderer.component";
import { SelectPoCellRendererComponent } from "./select-po-cell-renderer/select-po-cell-renderer.component";
import { SellerIdWithHyperlinkCellRendererComponent } from "./seller-id-with-hyperlink-cell-renderer/seller-id-with-hyperlink-cell-renderer.component";
import { SgSkuQtyCellRendererComponent } from "./sg-sku-qty-cell-renderer/sg-sku-qty-cell-renderer.component";
import { SimpleListCellRendererComponent } from "./simple-list-cell-renderer/simple-list-cell-renderer.component";
import { SinglePriceCellRendererComponent } from "./single-price-cell-renderer/single-price-cell-renderer.component";
import { SizeCellRendererComponent } from "./size-cell-renderer/size-cell-renderer.component";
import { SkuCellRendererComponent } from "./sku-cell-renderer/sku-cell-renderer.component";
import { SkuToolPanelComponent } from "./sku-tool-panel/sku-tool-panel.component";
import { StatusBarRendererComponent } from "./status-bar-renderer/status-bar-renderer.component";
import { StockHistoryCellRendererComponent } from "./stock-history-cell-renderer/stock-history-cell-renderer.component";
import { TooltipDialogComponent } from "./avg-price-tooltip-cell-renderer/tooltip-dialog/tooltip-dialog.component";
import { MultiPriceyardPanelComponent } from "./multi-sku-tool-panel/multi-priceyard-panel/multi-priceyard-panel.component";
import { MultiShipyardPanelComponent } from "./multi-sku-tool-panel/multi-shipyard-panel/multi-shipyard-panel.component";
import { OrderStatusComponent } from './order-status-cell-renderer/order-status/order-status.component';
import { ListExpandDialogComponent } from "./simple-list-cell-renderer/list-expand-dialog/list-expand-dialog.component";
import { PlanyardPanelComponent } from "./sku-tool-panel/planyard-panel/planyard-panel.component";
import { PriceyardPanelComponent } from "./sku-tool-panel/priceyard-panel/priceyard-panel.component";
import { ShipyardPanelComponent } from "./sku-tool-panel/shipyard-panel/shipyard-panel.component";
import { CustomHeaderTooltipComponent } from './custom-header-tooltip/custom-header-tooltip.component';
import { ProductPriceCellRendererComponent } from "./product-price-cell-renderer/product-price-cell-renderer.component";
import { PriceTooltipComponent } from "./product-price-cell-renderer/price-tooltip/price-tooltip.component";
import { ShipmentNameCellRendererComponent } from "./shipment-name-cell-renderer/shipment-name-cell-renderer.component";
import { InboundStockTooltipComponent } from './avg-price-tooltip-cell-renderer/inbound-stock-tooltip/inbound-stock-tooltip.component';
import { FbmOrderCellRendererComponent } from "./fbm-order-cell-renderer/fbm-order-cell-renderer.component";
import { FbmBatchIdCellRendererComponent } from "./fbm-batch-id-cell-renderer/fbm-batch-id-cell-renderer.component";
import { FbmOrdersPackedCountCellRendererComponent } from "./fbm-orders-packed-count-cell-renderer/fbm-orders-packed-count-cell-renderer.component";
import { ShipBatchCellRendererComponent } from "./ship-batch-cell-renderer/ship-batch-cell-renderer.component";
import { FbmOrderToolPanelComponent } from './fbm-order-tool-panel/fbm-order-tool-panel.component';
import { PipesModule } from "../pipes/pipes.module";
import { FulfilmentComponent } from './fbm-order-tool-panel/fulfilment/fulfilment.component';
import { FbmSkusComponent } from './fbm-order-tool-panel/fbm-skus/fbm-skus.component';
import { FbmFinancialsComponent } from './fbm-order-tool-panel/fbm-financials/fbm-financials.component';
import { FbmOrderCustomTooltipComponent } from "./fbm-order-custom-tooltip/fbm-order-custom-tooltip.component";
import { FinancialsStatusBarComponent } from './fbm-order-tool-panel/financials-status-bar/financials-status-bar.component';
import { CustomGridHeaderComponent } from './custom-grid-header/custom-grid-header.component';
import { WarehousesTooltipComponent } from "./warehouses-tooltip/warehouses-tooltip.component";
import { CasesCellRendererComponent } from './cases-cell-renderer/cases-cell-renderer.component';
import { ExpectedProfitCellRendererComponent } from './expected-profit-cell-renderer/expected-profit-cell-renderer.component';
import { SettlementCellRendererComponent } from './settlement-cell-renderer/settlement-cell-renderer.component';
import { CostToolPanelComponent } from './cost-tool-panel/cost-tool-panel.component';
import { CustomCostCellRendererComponent } from './custom-cost-cell-renderer/custom-cost-cell-renderer.component';
import { InvoiceDetailCellRendererComponent } from './invoice-detail-cell-renderer/invoice-detail-cell-renderer.component';
import { QtyWithTooltipCellRendererComponent } from './qty-with-tooltip-cell-renderer/qty-with-tooltip-cell-renderer.component';
import { TagsColorCellrendererComponent } from './tags-color-cellrenderer/tags-color-cellrenderer.component';
import { ToggleCellRendererComponent } from './toggle-cell-renderer/toggle-cell-renderer.component';
import { TagCellRendererComponent } from './tag-cell-renderer/tag-cell-renderer.component';
import { DashboardPriceyardPanelComponent } from './sku-tool-panel/dashboard-priceyard-panel/dashboard-priceyard-panel.component';
import { SellerCellRendererComponent } from './seller-cell-renderer/seller-cell-renderer.component';
import { BuyBoxGraphDetailsComponent } from './buy-box-graph-details/buy-box-graph-details.component';
import { DimentionsCellRendererComponent } from './dimentions-cell-renderer/dimentions-cell-renderer.component';
import {AgGridModule } from "@ag-grid-community/angular";
import { EditSizePopupComponent } from './edit-size-popup/edit-size-popup.component';
import { IgnoreWheelDirectiveModule } from "../directives/ignore-wheel.directive";
import { ClaimCenterToolPanelComponent } from './claim-center-tool-panel/claim-center-tool-panel.component';
import { CaseStatusCellRendererComponent } from './case-status-cell-renderer/case-status-cell-renderer.component';
import { NetProfitStatsComponent } from './net-profit-stats/net-profit-stats.component';
import { ColorPickerService } from "ngx-color-picker";
import { WarehouseAddressCellRendererComponent } from "./warehouse-address-cell-renderer/warehouse-address-cell-renderer.component";
import { BatchPickCellRendererComponent } from "./batch-pick-cell-renderer/batch-pick-cell-renderer.component";
import { ShipmentStatusCellRendererComponent } from "./shipment-status-cell-renderer/shipment-status-cell-renderer.component";


@NgModule({
  declarations: [
    BuyBoxCellRendererComponent,
    BuyBoxCellEditorComponent,
    BooleanCellRendererComponent,
    NoteCellRendererComponent,
    RankCellRendererComponent,
    SkuCellRendererComponent,
    BatchPickCellRendererComponent,
    DateCellRendererComponent,
    DiscountPricePercentCellEditComponent,
    PriceOverrideCellRendererComponent,
    PriceOverrideCellEditorComponent,
    RepricingModelCellRendererComponent,
    RepricingModelCellEditorComponent,
    LoadingCellRendererComponent,
    OffersCellRendererComponent,
    MultiEditComponent,
    SkuToolPanelComponent,
    AmountInShipmentCellRendererComponent,
    MultiPriceCellRendererComponent,
    ColumnSelectorHeaderRendererComponent,
    SinglePriceCellRendererComponent,
    NumberAndTrendCellRendererComponent,
    SimpleListCellRendererComponent,
    StatusBarRendererComponent,
    MultiSkuToolPanelComponent,
    BooleanFilterComponent,
    OrderInfoCellRendererComponent,
    OrderStatusCellRendererComponent,
    SellerIdWithHyperlinkCellRendererComponent,
    ShipyardPanelComponent,
    PriceyardPanelComponent,
    PlanyardPanelComponent,
    ChannelsCellRendererComponent,
    SizeCellRendererComponent,
    BtnCellRendererComponent,
    GridCheckboxHeaderRendererComponent,
    AddressCellRendererComponent,
    SelectOptionCellRendererComponent,
    SelectPoCellRendererComponent,
    ImageCellRendererComponent,
    DeleteIconRendererComponent,
    SelectFilterComponent,
    StockHistoryCellRendererComponent,
    ListExpandDialogComponent,
    MultiShipyardPanelComponent,
    MultiPriceyardPanelComponent,
    SgSkuQtyCellRendererComponent,
    MultiFieldCellRendererComponent,
    AvgPriceTooltipCellRendererComponent,
    ItemListCellRendererComponent,
    InternalNoteCellRendererComponent,
    TooltipDialogComponent,
    AccountCellRendererComponent,
    CheckboxCellRendererComponent,
    ReceivedQtyCellEditComponent,
    CustomHeaderTooltipComponent,
    OrderStatusComponent,
    RoundCheckboxCellRendererComponent,
    ShipmentNameCellRendererComponent,
    ProductPriceCellRendererComponent,
    PriceTooltipComponent,
    LinkCellRendererComponent,
    InboundStockTooltipComponent,
    FbmOrderCellRendererComponent,
    FbmBatchIdCellRendererComponent,
    ShipBatchCellRendererComponent,
    FbmOrdersPackedCountCellRendererComponent,
    FbmOrderToolPanelComponent,
    FulfilmentComponent,
    FbmSkusComponent,
    FbmFinancialsComponent,
    FbmOrderCustomTooltipComponent,
    FinancialsStatusBarComponent,
    CustomGridHeaderComponent,
    WarehousesTooltipComponent,
    CasesCellRendererComponent,
    ExpectedProfitCellRendererComponent,
    SettlementCellRendererComponent,
    CostToolPanelComponent,
    CustomCostCellRendererComponent,
    InvoiceDetailCellRendererComponent,
    QtyWithTooltipCellRendererComponent,
    TagsColorCellrendererComponent,
    ToggleCellRendererComponent,
    TagCellRendererComponent,
    DashboardPriceyardPanelComponent,
    SellerCellRendererComponent,
    BuyBoxGraphDetailsComponent,
    DimentionsCellRendererComponent,
    EditSizePopupComponent,
    ClaimCenterToolPanelComponent,
    CaseStatusCellRendererComponent,
    NetProfitStatsComponent,
    WarehouseAddressCellRendererComponent,
    ShipmentStatusCellRendererComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DetailModule,
    ComponentsModule,
    CustomDateDirectiveModule,
    DecimalNumberDirectiveModule,
    PipesModule,
    AgGridModule,
    IgnoreWheelDirectiveModule
  ],
  exports: [
    BuyBoxCellRendererComponent,
    BuyBoxCellEditorComponent,
    BooleanCellRendererComponent,
    NoteCellRendererComponent,
    RankCellRendererComponent,
    SkuCellRendererComponent,
    BatchPickCellRendererComponent,
    DateCellRendererComponent,
    DiscountPricePercentCellEditComponent,
    PriceOverrideCellRendererComponent,
    PriceOverrideCellEditorComponent,
    RepricingModelCellRendererComponent,
    RepricingModelCellEditorComponent,
    LoadingCellRendererComponent,
    OffersCellRendererComponent,
    MultiEditComponent,
    SkuToolPanelComponent,
    AmountInShipmentCellRendererComponent,
    MultiPriceCellRendererComponent,
    SinglePriceCellRendererComponent,
    NumberAndTrendCellRendererComponent,
    SimpleListCellRendererComponent,
    MultiSkuToolPanelComponent,
    BooleanFilterComponent,
    OrderInfoCellRendererComponent,
    ChannelsCellRendererComponent,
    SizeCellRendererComponent,
    BtnCellRendererComponent,
    AddressCellRendererComponent,
    SelectOptionCellRendererComponent,
    SelectPoCellRendererComponent,
    ImageCellRendererComponent,
    DeleteIconRendererComponent,
    SelectFilterComponent,
    StockHistoryCellRendererComponent,
    ItemListCellRendererComponent,
    InternalNoteCellRendererComponent,
    TooltipDialogComponent,
    AccountCellRendererComponent,
    CheckboxCellRendererComponent,
    ReceivedQtyCellEditComponent,
    RoundCheckboxCellRendererComponent,
    ShipmentNameCellRendererComponent,
    LinkCellRendererComponent,
    FbmOrderCellRendererComponent,
    FbmBatchIdCellRendererComponent,
    ShipBatchCellRendererComponent,
    OrderStatusComponent,
    FbmOrdersPackedCountCellRendererComponent,
    FbmOrderToolPanelComponent,
    FbmOrderCustomTooltipComponent,
    FinancialsStatusBarComponent,
    FbmFinancialsComponent,
    CostToolPanelComponent,
    CustomCostCellRendererComponent,
    QtyWithTooltipCellRendererComponent,
    TagsColorCellrendererComponent,
    ToggleCellRendererComponent,
    TagCellRendererComponent,
    DashboardPriceyardPanelComponent,
    PlanyardPanelComponent,
    NetProfitStatsComponent,
    WarehouseAddressCellRendererComponent,
    ShipmentStatusCellRendererComponent
  ],
  providers: [CurrencyPipe,ColorPickerService],
})
export class AgGridComponentsModule {}
